export default "__VITE_ASSET__CfsSJCED__"